export const LOCAL_STORAGE = {
  IS_SSO_LOGIN: "is_sso_login",
  TOKEN: "token",
  TOKEN_EXPIRE: "tokenExpire",
  THEME_COLOR: "theme",
  LANGUAGE: "language",
  AUTH: "authType",
  REFRESH_TOKEN: "refreshToken",
};
